import schema from './Schema'

export default class Participant {
  constructor(data = {}) {
    Object.assign(this, schema, data)
  }
}
